// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"921":"aca034e6","9367":"867abd88"}[chunkId] + ".chunk.css";
};